import Decimal from 'decimal.js';

export const roundToFixed = (value: number, precision: number) => {
  const numberString = value.toString();

  const decimalIndex = numberString.indexOf('.');

  if (decimalIndex === -1) {
    return value;
  }

  const integerPart = numberString.slice(0, decimalIndex);
  const decimalPart = numberString.slice(decimalIndex + 1, decimalIndex + 3);

  const truncatedString = integerPart + '.' + decimalPart;

  return new Decimal(truncatedString).toNumber();
};

export const roundToFixed2 = (value: number, precision: number) => {
  const multiplier = 10 ** precision;
  return (Math.round(value * multiplier) / multiplier).toFixed(2);
};

export const getIntegerHandler = (int: number): string => (int ? int.toFixed(2) : (0).toFixed(2));

export const preciseAddSubtract = (num1: number, num2: number, operation: 'add' | 'subtract') => {
  const intNum1 = new Decimal((num1 || 0).toString());
  const intNum2 = new Decimal((num2 || 0).toString());

  let result: Decimal;
  if (operation === 'add') {
    result = intNum1.plus(intNum2);
  } else if (operation === 'subtract') {
    result = intNum1.minus(intNum2);
  } else {
    throw new Error('Unsupported operation');
  }

  return result.toNumber();
};
